import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { INavigationAuditRegexResponse } from '../../types/api/response/navigationauditregexresponse';
import { INavigationAuditRegexState } from '../../types/store';

const initialState: INavigationAuditRegexState = {
  mappings: [],
};

const navigationAuditRegexSlice = createSlice({
  name: 'navigationAuditRegexSlice',
  initialState,
  reducers: {
    setMappings: (state, action: PayloadAction<INavigationAuditRegexResponse[]>) => {
      state.mappings = action.payload;
    },
    addMapping: (state, action: PayloadAction<INavigationAuditRegexResponse>) => {
      state.mappings.push(action.payload);
    },
    updateMapping: (state, action: PayloadAction<INavigationAuditRegexResponse>) => {
      const idx = state.mappings.findIndex((m) => m.id === action.payload.id);
      if (idx > -1) state.mappings[idx] = action.payload;
    },
    removeMapping: (state, action: PayloadAction<number>) => {
      state.mappings = state.mappings.filter((m) => m.id !== action.payload);
    },
  },
});

export const { setMappings, addMapping, updateMapping, removeMapping } =
  navigationAuditRegexSlice.actions;

export default navigationAuditRegexSlice.reducer;
